export default __webpack_public_path__ + "static/media/percent-fill.08d11c3c.png";